import type { SxProps, Theme } from "@mui/material"

export const TINT = "color-mix(in srgb, var(--app-primary) 7%, transparent)"
export const EDGE = "color-mix(in srgb, var(--app-primary) 55%, transparent)"

export const CARD_SX = ((theme: Theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  p: 2,
  mt: 1.5,
  borderRadius: 2,
  bgcolor: TINT,
  borderColor: EDGE,
  ...theme.applyStyles("dark", { backgroundColor: TINT, borderColor: EDGE }),
})) satisfies SxProps<Theme>
export const HEAD_SX = { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" } satisfies SxProps<Theme>
export const NAME_SX = { fontWeight: 600, minWidth: 0, overflowWrap: "anywhere" } satisfies SxProps<Theme>
export const DESCRIPTION_SX = {
  color: "text.secondary", overflow: "hidden", overflowWrap: "anywhere",
  display: "-webkit-box", WebkitBoxOrient: "vertical", WebkitLineClamp: 1,
} satisfies SxProps<Theme>
export const ACTIONS_SX = { display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" } satisfies SxProps<Theme>
export const PREVIEW_SX = { ml: "auto", flexShrink: 0 } satisfies SxProps<Theme>
export const LINES_SX = { m: 0, pl: 2.5 } satisfies SxProps<Theme>
